import { useState } from 'react';
import { wikiQuery, WikiQueryResponse } from '../api/wiki';

export function QueryConsole({ pid }: { pid: string }) {
  const [question, setQuestion] = useState('');
  const [fileBack, setFileBack] = useState(false);
  const [busy, setBusy] = useState(false);
  const [resp, setResp] = useState<WikiQueryResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!question.trim()) return;
    setBusy(true);
    setError(null);
    try {
      const r = await wikiQuery(pid, {
        question: question.trim(),
        mode: 'hybrid',
        file_back: fileBack,
      });
      setResp(r);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <a href={`#/wiki/p/${encodeURIComponent(pid)}`}>← Project</a>
      <h2 style={{ marginTop: 8 }}>Ask the wiki</h2>
      <form onSubmit={submit} style={{ marginBottom: 16 }}>
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="What does this project know about…?"
          style={{ width: '100%', minHeight: 80, padding: 8 }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 8,
          }}
        >
          <label className="muted small">
            <input
              type="checkbox"
              checked={fileBack}
              onChange={(e) => setFileBack(e.target.checked)}
            />{' '}
            File the answer as a synthesis page
          </label>
          <button type="submit" disabled={busy || !question.trim()}>
            {busy ? 'Synthesising…' : 'Ask'}
          </button>
        </div>
      </form>

      {error ? <div className="banner banner-warning">{error}</div> : null}

      {resp ? (
        <div>
          <div className="muted small" style={{ marginBottom: 12 }}>
            confidence: {resp.confidence_signal} · {resp.tokens_used} tokens ·{' '}
            {resp.took_ms} ms
            {resp.filed_as
              ? ` · filed as ${resp.filed_as.slug}`
              : ''}
          </div>
          <article
            style={{
              fontFamily: '"Source Serif Pro", Charter, Georgia, serif',
              fontSize: 17,
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
            }}
          >
            {resp.answer_markdown}
          </article>
          {resp.citations.length > 0 ? (
            <details style={{ marginTop: 16 }}>
              <summary>{resp.citations.length} citations</summary>
              <ol>
                {resp.citations.map((c) => (
                  <li key={c.marker}>
                    <strong>{c.source_title}</strong>{' '}
                    <span className="muted small">
                      [{c.source_table}:{c.source_id}@{c.span_start}-{c.span_end}]
                    </span>
                    <blockquote>{c.quote}</blockquote>
                  </li>
                ))}
              </ol>
            </details>
          ) : null}
          {resp.pages_consulted.length > 0 ? (
            <div className="muted small" style={{ marginTop: 12 }}>
              Pages consulted:{' '}
              {resp.pages_consulted.map((p) => p.slug).join(', ')}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
